// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SubNavBar-subNavBarContainer-GVKv2 {
  background: var(--subHeader-bg);
  position: fixed;
  top: var(--frontPage-header-height);
  left: 0;
  right: 0;
  width: 100%;
  padding: 10px 0;
  z-index: 1031;
}

.SubNavBar-subNavBarList-UnUbA {
  list-style-type: none;
  padding: 0 !important;
  margin: 0 !important;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: start;
      -ms-flex-pack: start;
          justify-content: flex-start;
  -ms-flex-wrap: nowrap;
      flex-wrap: nowrap;
  gap: 6px;
  grid-gap: 6px;
  /* Never clip a label: keep every item full-width and let the row scroll on narrow desktops.
     Scrollbar hidden for a clean look (still scrolls via trackpad / shift-wheel). */
  overflow-x: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.SubNavBar-subNavBarList-UnUbA::-webkit-scrollbar {
  display: none;
}

.SubNavBar-subNavBarList-UnUbA > li {
  -webkit-box-flex: 0;
      -ms-flex: 0 0 auto;
          flex: 0 0 auto;
}

.SubNavBar-subNavBarImgContainer-tW38I {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  padding: 5px;
  background: var(--subHeader-btn-bg);
  border-radius: 50%;
}

.SubNavBar-subNavBarImgContainer-tW38I img {
  width: 16px;
  height: 16px;
}

.SubNavBar-subNavBarItem-BO9RO.SubNavBar-active-ZEDHP .SubNavBar-subNavBarImgContainer-tW38I {
  background: var(--primary-bg);
}

.SubNavBar-subNavBarItem-BO9RO,
.SubNavBar-subNavBarItem-BO9RO:hover,
.SubNavBar-subNavBarItem-BO9RO:focus {
  padding: 4px 12px 4px 4px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  gap: 6px;
  grid-gap: 6px;
  font-size: 14px;
  line-height: 22px;
  font-weight: 600;
  white-space: nowrap;
  color: var(--common-primary-white-foreground);
  text-decoration: unset;
  background: transparent;
  border-radius: 30px;
}

.SubNavBar-subNavBarItem-BO9RO.SubNavBar-active-ZEDHP {
  background: var(--subHeader-btn-bg);
}

@media (max-width: 991px) {
  .SubNavBar-subNavBarContainer-GVKv2 {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/SubNavBar/SubNavBar.css"],"names":[],"mappings":"AAAA;EACE,+BAA+B;EAC/B,eAAe;EACf,mCAAmC;EACnC,OAAO;EACP,QAAQ;EACR,WAAW;EACX,eAAe;EACf,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,oBAAoB;EACpB,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,uBAA2B;MAA3B,oBAA2B;UAA3B,2BAA2B;EAC3B,qBAAiB;MAAjB,iBAAiB;EACjB,QAAQ;EACR,aAAa;EACb;oFACkF;EAClF,gBAAgB;EAChB,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAc;MAAd,kBAAc;UAAd,cAAc;AAChB;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,YAAY;EACZ,mCAAmC;EACnC,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;;;EAGE,yBAAyB;EACzB,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,QAAQ;EACR,aAAa;EACb,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,6CAA6C;EAC7C,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE;IACE,aAAa;EACf;AACF","sourcesContent":[".subNavBarContainer {\n  background: var(--subHeader-bg);\n  position: fixed;\n  top: var(--frontPage-header-height);\n  left: 0;\n  right: 0;\n  width: 100%;\n  padding: 10px 0;\n  z-index: 1031;\n}\n\n.subNavBarList {\n  list-style-type: none;\n  padding: 0 !important;\n  margin: 0 !important;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  flex-wrap: nowrap;\n  gap: 6px;\n  grid-gap: 6px;\n  /* Never clip a label: keep every item full-width and let the row scroll on narrow desktops.\n     Scrollbar hidden for a clean look (still scrolls via trackpad / shift-wheel). */\n  overflow-x: auto;\n  scrollbar-width: none;\n  -ms-overflow-style: none;\n}\n\n.subNavBarList::-webkit-scrollbar {\n  display: none;\n}\n\n.subNavBarList > li {\n  flex: 0 0 auto;\n}\n\n.subNavBarImgContainer {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 5px;\n  background: var(--subHeader-btn-bg);\n  border-radius: 50%;\n}\n\n.subNavBarImgContainer img {\n  width: 16px;\n  height: 16px;\n}\n\n.subNavBarItem.active .subNavBarImgContainer {\n  background: var(--primary-bg);\n}\n\n.subNavBarItem,\n.subNavBarItem:hover,\n.subNavBarItem:focus {\n  padding: 4px 12px 4px 4px;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  grid-gap: 6px;\n  font-size: 14px;\n  line-height: 22px;\n  font-weight: 600;\n  white-space: nowrap;\n  color: var(--common-primary-white-foreground);\n  text-decoration: unset;\n  background: transparent;\n  border-radius: 30px;\n}\n\n.subNavBarItem.active {\n  background: var(--subHeader-btn-bg);\n}\n\n@media (max-width: 991px) {\n  .subNavBarContainer {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"subNavBarContainer": `SubNavBar-subNavBarContainer-GVKv2`,
	"subNavBarList": `SubNavBar-subNavBarList-UnUbA`,
	"subNavBarImgContainer": `SubNavBar-subNavBarImgContainer-tW38I`,
	"subNavBarItem": `SubNavBar-subNavBarItem-BO9RO`,
	"active": `SubNavBar-active-ZEDHP`
};
module.exports = ___CSS_LOADER_EXPORT___;
